

































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { GetRequest } from '@/store/requeststate';
import BookmarkColumn from '@/components/bookmark/BookmarkColumn.vue';
import BookmarkForm from '@/components/bookmark/BookmarkForm.vue';
import CommonHeader from '@/components/common/CommonHeader.vue';
import { BookmarkBean } from '@/types';
import firebase from 'firebase';
import Rss from '@/components/rss/Rss.vue';

@Component({
    components: {
        Rss,
        BookmarkColumn,
        CommonHeader,
        BookmarkForm,
    },
})
export default class BookmarkPage extends Vue {
    @Action('get', {namespace: 'requestState'})
    public get!: (req: GetRequest) => Promise<any>;

    private tag: string = '';

    private list: BookmarkBean[] = [];

    private async mounted() {
        try {
            this.list = await this.get({path: 'api/bookmark/list', params: {}});
        } catch (e) {
            if (e.message === 'Request failed with status code 401') {
                firebase.auth().signOut().then(() => {
                    this.$router.push('/signin');
                });
            } else {
                throw e;
            }
        }
    }

    private get tags(): string[] {
        const results: string[] = [''];
        for (const bean of this.list) {
            const tags = bean.tags.split(',');
            for (const tag of tags) {
                if (!results.includes(tag)) {
                    results.push(tag);
                }
            }
        }
        return results;
    }
}
